import React from 'react'
import PropTypes from 'prop-types'

// Bordered row that lays KpiCard tiles side by side with dividers.
// KpiCardGroup builds the standard Statistics / Evolution row on top of it.
// Pages needing another set of tiles compose them directly.
const ROW_CLASSES = 'tw:flex tw:flex-wrap tw:items-stretch tw:bg-white '
  + 'tw:border tw:border-solid tw:border-gray-300 tw:rounded! '
  + 'tw:divide-x tw:divide-gray-300 tw:overflow-hidden'

const KpiCardRow = ({ children, className }) =>
  <div className={`${ROW_CLASSES} ${className}`}>{children}</div>

KpiCardRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

KpiCardRow.defaultProps = {
  className: ''
}

export default KpiCardRow
